import { BaseCriteriaModel } from './base-criteria.model';
import { Optional } from 'typescript-optional';

export class InventoryOpdgElementReportQueryCriteriaClass extends BaseCriteriaModel {
  locationGuid?: Optional<string> = Optional.empty();
  hdrGuid?: Optional<string> = Optional.empty();
  brandGuid?: Optional<string> = Optional.empty();
  outletCode?: Optional<string> = Optional.empty();
  hdrStatus?: Optional<string> = Optional.empty();
  categoryL1Guid?: Optional<string> = Optional.empty();
  categoryL2Guid?: Optional<string> = Optional.empty();
  categoryL3Guid?: Optional<string> = Optional.empty();
  outletSizeCode?: Optional<string> = Optional.empty();
  outletTypeCode?: Optional<string> = Optional.empty();
  createdDateFrom?: Optional<string> = Optional.empty();
  createdDateTo?: Optional<string> = Optional.empty();
}

export class InventoryOpdgElementReportQueryCriteriaModelQuery {
  query = '';

  constructor(inventoryOpdgElementReportCriteriaModel: InventoryOpdgElementReportQueryCriteriaClass) {
    if (!inventoryOpdgElementReportCriteriaModel) {
      return;
    }

    this.query += inventoryOpdgElementReportCriteriaModel.locationGuid.filter(x => x !== '').map(x => '&locationGuid=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.hdrGuid.filter(x => x !== '').map(x => '&hdrGuid=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.brandGuid.filter(x => x !== '').map(x => '&brandGuid=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.outletCode.filter(x => x !== '').map(x => '&outletCode=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.hdrStatus.filter(x => x !== '').map(x => '&hdrStatus=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.categoryL1Guid.filter(x => x !== '').map(x => '&categoryL1Guid=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.categoryL2Guid.filter(x => x !== '').map(x => '&categoryL2Guid=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.categoryL3Guid.filter(x => x !== '').map(x => '&categoryL3Guid=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.outletSizeCode.filter(x => x !== '').map(x => '&outletSizeCode=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.outletTypeCode.filter(x => x !== '').map(x => '&outletTypeCode=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.createdDateFrom.filter(x => x !== '').map(x => '&createdDateFrom=' + x).orElse('');
    this.query += inventoryOpdgElementReportCriteriaModel.createdDateTo.filter(x => x !== '').map(x => '&createdDateTo=' + x).orElse('');

    this.query += '&status=' + inventoryOpdgElementReportCriteriaModel.status;
    this.query += '&orderBy=' + inventoryOpdgElementReportCriteriaModel.orderBy;
    this.query += '&order=' + inventoryOpdgElementReportCriteriaModel.order;
    this.query += '&offset=' + inventoryOpdgElementReportCriteriaModel.offset + '&limit=' + inventoryOpdgElementReportCriteriaModel.limit;
    this.query += '&calcTotalRecords=' + inventoryOpdgElementReportCriteriaModel.calcTotalRecords;
  }
}
